import { createSlice } from "@reduxjs/toolkit";
const locationSlice = createSlice({
    name: "location",
    initialState: {

    },
    reducers: {
        addLocation(state, action) {
            return state = action.payload;
        },
        updateLocation(state, action) {
            state = { ...state, ...action.payload }
        },
        clearLocation(state, action) {
            return state = {}
        }
    },
});
export const { addLocation, updateLocation, clearLocation } = locationSlice.actions;
export default locationSlice.reducer;